

import { getAuthenticatedClient } from "../auth/authClient";
import log from 'loglevel';

var graph = require('@microsoft/microsoft-graph-client');

export const emailServiceSend = (recepients, subject, body, contentType, accessToken) => {

    log.info(` @emailServiceSend`);
    log.debug(`@emailServiceSend accessToken: ${accessToken}`);
  
    const res =  emailServiceAPISend(recepients, subject, body, contentType, accessToken);
}

// function getAuthenticatedClient(accessToken) {
//     log.info(`getAuthenticatedClient @emailServiceSend`);

//         try {
            
//             const client = graph.Client.init({
//             authProvider: (done) => {
//                 done(null, accessToken.accessToken);
//             }
//             });
//             return client;

//         } catch (error) {
//             log.error(`error / getAuthenticatedClient @emailServiceSend ${JSON.stringify(error)}`);
//         } finally {
//             log.info(`finally / getAuthenticatedClient @emailServiceSend`);
//         } 
// }

const emailServiceAPISend = async (recepients, subject, body, contentType, accessToken) =>{  
    log.info(`emailServiceAPISend @emailServiceSend`);
    //Cretae an array of receipients
    const emailA1 = recepients.split(";"); 
    const emailT = emailA1.map((adr)=>(
        {
            emailAddress: { 
            address : adr
            }
        }
        ));

    //compose the email object    
    const sendMail = {
        message: { 
            subject: subject,
            body:   { 
                        contentType: contentType, //"HTML",//Text, //
                        content: body 
                    },
            toRecipients: [...emailT]

        } 
    };

    try{            
        const client = getAuthenticatedClient(accessToken);

        const res = await client
                    .api('/me/sendMail')
                    .headers({
                        "Content-Type" : "application/json",
                        "mode": "cors",
                        "Access-Control-Allow-Origin" : '' 
                        })
                    .version('v1.0')
                    .post(sendMail) ;
                    }
    catch (error) {
        log.info(`error / emailServiceAPISend @emailServiceSend ${JSON.stringify(error)}`);
    } finally {
        log.info(`finally / emailServiceAPISend @emailServiceSend`);
    } 
}
